module.exports = angular.module('add-to-segment-ctrl', []).controller('addToSegmentFormCtrl', [
    '$rootScope',
    '$scope',
    'canvasService',
    function ($rootScope, $scope, canvasService) {
        $scope.displayAddListActionOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.createListName = {};
        $scope.search = {};

        if ($scope.connections.length !== undefined) {
            let now = new Date();

            //Start new Connection obj
            $scope.connections = {
                id: 'entry_' + now.getTime(),
                data: {
                    selectedList: [],
                    contactOptions: 'add-contacts-future',
                    listData: [],
                },
            };
        }

        $scope.$parent.connections = $scope.connections;

        $scope.contactOptions = [
            {
                value: 'all-in-any-future',
                message: $scope.translate('commons.all.subscribers'),
            },
            {
                value: 'add-contacts-list',
                message: $scope.translate('commons.existing.subscribers'),
            },
            {
                value: 'add-contacts-future',
                message: $scope.translate('commons.new.subscribers'),
            },
        ];

        $scope.sortDataList = () => {
            $scope.segmentData = $scope.segmentData.map((i) => {
                if ($scope.connections.data.selectedList.indexOf(i.SegmentId) > -1) {
                    i.selectedItem = true;
                } else {
                    delete i.selectedItem;
                }

                return i;
            });

            Object.assign(
                $scope.segmentData,
                _.orderBy($scope.segmentData, ['selectedItem'], ['asc'])
            );
        };
        $scope.segmentData && $scope.segmentData.length && $scope.sortDataList();

        $scope.toggelListItem = function (listItem, $i) {
            if ($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            var index = $scope.connections.data.selectedList.indexOf(listItem);
            if (index > -1) {
                $scope.connections.data.selectedList.splice(index, 1);
                delete $scope.segmentData[$i].selectedItem;
            } else {
                $scope.connections.data.selectedList.push(listItem);
                $scope.segmentData[$i].selectedItem = true;
            }

            Object.assign(
                $scope.segmentData,
                _.orderBy($scope.segmentData, ['selectedItem'], ['asc'])
            );

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('commons.selectSegment');
            }
        };

        $scope.setSegmentScrollLogic = function (id) {
            $scope.listLoader = false;
            angular
                .element(document.getElementById('contactSegmentContainer' + id))
                .bind('scroll', function () {
                    if (
                        !$scope.listLoader &&
                        !$rootScope.stopLoadingSegments &&
                        !$scope.search.list
                    ) {
                        $scope.listLoader = true;
                        canvasService
                            .getSegments($rootScope.segmentListOffset, 10)
                            .success(function (data) {
                                if (!data.Results.length) {
                                    $rootScope.stopLoadingSegments = true;
                                } else {
                                    $rootScope.segmentListOffset++;
                                    $rootScope.segmentData = _.uniqBy(
                                        $rootScope.segmentData.concat(data.Results),
                                        'SegmentId'
                                    );
                                    $scope.segmentData = $rootScope.segmentData;
                                }
                                $scope.listLoader = false;
                                $scope.sortDataList();
                            })
                            .error(function () {
                                $scope.listLoader = false;
                            });
                    }
                });
        };

        $scope.searching = false;
        $scope.search.search = (val) => {
            if (val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService
                    .searchContactSegment(val)
                    .then((res) => {
                        $scope.searching = false;
                        $rootScope.segmentData = _.uniqBy(
                            $rootScope.segmentData.concat(res.data.Results),
                            'ListId'
                        );
                        $scope.segmentData = [];
                        if (
                            $scope.connections.data.selectedList &&
                            $scope.connections.data.selectedList.length
                        ) {
                            $scope.connections.data.selectedList.forEach((item) => {
                                for (let i = 0; i < $rootScope.segmentData.length; i++) {
                                    if ($rootScope.segmentData[i].ListId === item) {
                                        $scope.segmentData.push($rootScope.segmentData[i]);
                                        break;
                                    }
                                }
                            });
                        }

                        $scope.segmentData = $scope.segmentData.concat(res.data.Results);
                        $scope.sortDataList();
                    })
                    .catch(() => {
                        $scope.searching = false;
                    });
            } else {
                $scope.segmentData = $rootScope.segmentData;
                $scope.sortDataList();
            }
        };

        setTimeout(function () {
            $scope.setSegmentScrollLogic($scope.connections.id);
        }, 100);

        $scope.$watch('connections.data.contactOptions', (newVal) => {
            $scope.showContactsWarning = newVal === 'add-contacts-list';
        });
    },
]);



// WEBPACK FOOTER //
// ./app/controllers/triggerPanel/addToSegmentFormCtrl.js